import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getGRNs } from "../../apis/grn";
import { Button, Dropdown, Tag} from "antd";
import CommonPagination from "../../components/CommanPagination";

const getStatusColor = (status: string) => {
  switch (status.toLowerCase()) {
    case "received":
      return "green";
    case "verified":
      return "blue";
    case "cancelled":
      return "default"; 
    default:
      return "default";
  }
};

const GRNs = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [grns, setGrns] = useState<any[]>([]);
  const [meta, setMeta] = useState<any>({});
  
const fetchGRNs = async (params: any = { page: 1, per_page: 10 }) => {
  setLoading(true);
  try {
    const response: any = await getGRNs(params);
   
    const mappedGRNs = (response.data || []).map((grn: any) => ({
      id: grn.id, 
      grnNo: grn.grnNumber,
      supplier: grn.supplier?.name || "",
      receivedOn: grn.receivedDate,
      invoiceNumber: grn.invoiceNumber,
      status: grn.status,
    }));
    setGrns(mappedGRNs);
    setMeta(response.meta);
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  fetchGRNs({ page: 1, per_page: 10 });
}, []);

const onPaginationChange = (page: number, pageSize?: number) => {
  fetchGRNs({ page, per_page: pageSize || 10 }); 
};

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-3">
        <h1 className="text-base font-semibold leading-6 text-gray-900">
          Good Received Notes
        </h1>
        <div className="flex gap-3">
          <button
            type="button"
            className="px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm bg-primary hover:bg-hover"
            onClick={() => navigate("/add-grn")}
          >
            Add GRNs
          </button>
          <button
            type="button"
            className="px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm bg-primary hover:bg-hover"
          >
            Export
          </button>
        </div>
      </div>

      <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-300">
              <thead className="bg-gray-50">
                <tr>
                  <th className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                    GRN No
                  </th>
                  <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                    Supplier
                  </th>
                  <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                    Received On
                  </th>
                  <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                    Invoice Number
                  </th>
                  <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                    Status
                  </th>
                  <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody className="bg-white divide-y divide-gray-200">
                {grns.map((grn, index) => (
                  <tr key={index}>
                    <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                      {grn.grnNo}
                    </td>
                    <td className="py-4 px-3 text-sm text-gray-700">
                      {grn.supplier}
                    </td>
                    <td className="py-4 px-3 text-sm text-gray-700">
                      {grn.receivedOn}
                    </td>
                    <td className="py-4 px-3 text-sm text-gray-700">
                      {grn.invoiceNumber}
                    </td>
                    <td className="py-4 px-3 text-sm text-gray-700 text-center">
                      <Tag color={getStatusColor(grn.status)}>
                        {grn.status?.replace("_", " ").toUpperCase()}
                      </Tag>
                    </td>
                    <td className="py-4 px-3 text-sm text-gray-700">
                      <td className="relative py-4 px-3 text-sm font-medium text-left whitespace-nowrap">
                        <Dropdown
                          menu={{
                            items: [
                              {
                                key: "view",
                                label: (
                                  <span onClick={() => navigate(`/grn/${grn.id}`)}>
                                    View
                                  </span>
                                ),
                              },
                              {
                                key: "edit",
                                label: (
                                  <span onClick={() => navigate(`/grns/edit/${grn.id}`)}>
                                    Edit
                                  </span>
                                ),
                              },
                            ],
                          }}
                          placement="bottomLeft"
                        >
                          <Button>Actions</Button>
                        </Dropdown>
                      </td>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {loading && (
              <div className="py-4 text-center text-gray-500">Loading...</div>
            )}
          </div>
          {/* <div className="flex justify-end pt-5">
        <Pagination
          defaultCurrent={1}
          defaultPageSize={10}
          total={meta?.total}
          onChange={onPaginationChange}
        />
      </div> */}
      <CommonPagination meta={meta} onChange={onPaginationChange} />
    </div>
  );
};

export default GRNs;
